module.exports = __webpack_public_path__ + "static/media/prospecto.9d98c925.svg";